<template>
  <div class="create-admin">
    <div class="bg-white">
      <div class="flex justify-between items-stretch shadow-border-b mdmax:flex-col">
        <div class="flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:w-full mdmax:flex-auto">
          <p class="font-bold text-lg mb-6">{{ $t('admin.create.addUser') }}</p>
          <div class="mb-6">
            <TextField type="text" v-model="payloads.name" :label="$t('admin.create.name')"
              :placeholder="$t('admin.create.namePlaceholder')" required />
          </div>
          <div class="mb-6">
            <TextField type="text" v-model="payloads.email" :label="$t('admin.create.email')"
              :placeholder="$t('admin.create.emailPlaceholder')" required />
          </div>
          <div class="mb-6">
            <TextField type="number" v-model="payloads.phone_number" :label="$t('admin.create.phone')"
              :placeholder="$t('admin.create.phonePlaceholder')" required />
          </div>
          <div class="mb-6">
            <TextField type="text" v-model="payloads.password" :placeholder="$t('admin.create.passwordPlaceholder')"
              :label="$t('admin.create.passwordPlaceholder')" required />
          </div>
        </div>
        <div class="flex-1 mdmax:w-full mdmax:flex-auto p-6"></div>
      </div>
      <div class="w-full bg-white p-6">
        <div class="flex gap-6 justify-end">
          <div class="">
            <Button :buttonText="$t('admin.create.save')" type="primary" @action="save()" :disabled="isDisabled" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button')
  },
  data: () => ({
    payloads: {
      email: null,
      phone_number: null,
      name: null,
      password: null
    }
  }),
  computed: {
    isDisabled() {
      return !this.payloads.email || !this.payloads.phone_number || !this.payloads.name || !this.payloads.password
    }
  },
  methods: {
    ...mapActions('merchant', ['createMerchantUser']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    save() {
      this.showLoading()
      this.createMerchantUser({
        payloads: this.payloads
      })
        .then(() => {
          this.hideLoading()
          this.resetPayload()
          this.setToast({
            options: { type: 'success', duration: 2000, primaryText: 'Penambahan User Berhasil', secondaryText: 'Data telah kami simpan', callback: this.handleCallback }
          })
        })
        .catch(res => {
          this.hideLoading()
          this.setToast({
            options: { type: 'danger', duration: 4000, primaryText: `Penambahan User Gagal, ${res.response.data.message}`, secondaryText: 'Silakan coba lagi.', callback: () => { } }
          })
        })
    },
    resetPayload() {
      this.payloads = {
        email: null,
        phone_number: null,
        name: null,
        password: null
      }
    },
    handleCallback() {
      this.$router.push('/admin')
    }
  }
}
</script>
